<template>
    <v-dialog v-model="modalProp" max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            >
                Input Error!
            </v-card-title>
            <div style="width:80%; margin:auto" class="">
                <v-card-text class="my-5 text-center subtitle-2">
                    {{
                        resultData
                    }}
                </v-card-text>
            </div>

            <v-card-actions>
                <v-spacer />

                <v-btn
                    color="red darken-1"
                    text
                    @click="modalProp = ''"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

  <script>
export default {
    props: ['showErrDiag', 'resultData'],
    data: () => ({}),
    computed: {
        modalProp: {
            get() {
                if (this.resultData == '') {
                    return false
                } else {
                    return this.showErrDiag
                }
            },
            set(val) {
                // console.log("oo dumaan dito");
                this.$emit('errorInput', val)
            }
        }
    }
}
  </script>

  <style></style>
